// extracted by mini-css-extract-plugin
export var bar = "scroller-module--bar--oe-ZF";
export var darkBar = "scroller-module--darkBar--QOnVd";
export var hidden = "scroller-module--hidden--TMcoV";
export var lightBar = "scroller-module--lightBar--AUlMK";
export var track = "scroller-module--track--I9wea";
export var vertical = "scroller-module--vertical--FkHTf";